export const USER_MOBILE="USER_MOBILE";
export const VERIFY_CODE="VERIFY_CODE";
export const AUTH_STEP="AUTH_STEP";
export const PLATFORM="PLATFORM";

export const setUserMobile=(mobile)=>{
    return(
        {
            type:USER_MOBILE,
            payload:mobile
        }
    )
}
export const setVerifyCode=(code)=>{
    return(
        {
            type:VERIFY_CODE,
            payload:code
        }
    )
}
export const setAuthTab=(authTab)=>{
    return(
        {
            type:AUTH_STEP,
            payload:authTab
        }
    )
}
export const setPlatform=(data)=>{
    return(
        {
            type:PLATFORM,
            payload:data
        }
    )
}